import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface Unidad {
  id: number;
  abreviatura: string;
  codigoAfip: number;
  denominacion: string;
}

export interface Unidades {
    unidades: Unidad[];
}

export interface UnidadesState {
  unidades: Unidad[];
  error: boolean;
  debugMessage?: any;
} 

export interface ObtenerListadoUnidadResponse extends ResponseMessageWithInternalStatus{
  unidades: {
      id: number,
      abreviatura: string,
      codigoAfip: number,
      denominacion: string
  }[]
}

export const initialUnidadesState: UnidadesState = {
  unidades: [],
  error: false,
  debugMessage: null
};
